import React from 'react';
import { Button } from 'antd';
import { CheckOutlined, EyeOutlined, RollbackOutlined } from '@ant-design/icons';
import I18n from 'i18n-js';
import { bool, func, string } from 'prop-types';

const FormActions = ({
  className = '',
  isFormSending = false,
  isDecisionSending = false,
  submitButtonName = '',
  reviewDecisionPending = false,
  onSubmit = () => {},
  onDecision = (_decision) => {},
}) => {
  if (reviewDecisionPending) {
    return (
      <div className={className}>
        <div className="tickets-index-page__review-decision">
          <div className="tickets-index-page__review-decision-title">
            <EyeOutlined />
            {I18n.t('tickets.form.review_decision_title')}
          </div>
          <div className="tickets-index-page__review-decision-hint">
            {I18n.t('tickets.form.review_decision_hint')}
          </div>
          <Button
            type="primary"
            block
            icon={<CheckOutlined />}
            loading={isDecisionSending}
            onClick={() => onDecision('close')}
          >
            {I18n.t('tickets.form.close_ticket')}
          </Button>
          <Button
            block
            icon={<RollbackOutlined />}
            loading={isDecisionSending}
            onClick={() => onDecision('reopen')}
          >
            {I18n.t('tickets.form.return_to_development')}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={className}>
      <Button
        type="primary"
        block
        loading={isFormSending}
        onClick={onSubmit}
      >
        {submitButtonName}
      </Button>
    </div>
  );
};

FormActions.propTypes = {
  className: string,
  isFormSending: bool,
  isDecisionSending: bool,
  submitButtonName: string,
  reviewDecisionPending: bool,
  onSubmit: func,
  onDecision: func,
};

export default FormActions;
